import { useState } from "react";
import MathJax from 'react-mathjax-preview';

/*Equivalent to python dict(zip(['AB', 'CD', 'EF', 'GH'],[1, 2, 3, 4])) in javascript
https://gist.github.com/ThomasG77/2186830
var keys = ['AB', 'CD', 'EF', 'GH'];
var values = [1, 2, 3, 4];
console.log(dictZip(keys, values));
*/
export function dictZip(key_array, val_array) {
  if (key_array.length === val_array.length) {
    return key_array.reduce((acc, curr, index) => {
      acc[curr] = val_array[index];
      return acc;
    }, {});
  } else {
    console.error("Wrong length");
  }
}

// sleep
export function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

//tex markup for math formulas
export const MathFormula = (texString) => {
/*     <MathFormula string="Recovery function: $X_{t+1}=X_{t} + \epsilon_{t+1}$" />
    <MathFormula string="Innovation function: $$\epsilon_{t+1}=X_{t+1}-X_{t}$$" /> */
    const [tex] = useState(texString);
    //console.log(tex.string);
    return (
        <MathJax math={tex.string} />
    )
}

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "")
    
  } catch (e) {
    console.log(e)
  }
};